import React from 'react';
import { Button } from './ui/button';
import { Check, X } from 'lucide-react';

const PricingCard = ({ package: pkg, onGetStarted }) => {
  return (
    <div className={`bg-slate-900 rounded-xl shadow-lg border-2 ${
      pkg.popular ? 'border-blue-500 relative' : 'border-slate-700'
    } p-8 transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/30 hover:border-blue-400 hover:-translate-y-2 min-w-[280px] h-full flex flex-col`}>
      {pkg.popular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-50">
          <span className="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-6 py-2 rounded-full text-sm font-bold shadow-xl border-2 border-amber-400 whitespace-nowrap">
            POPULAR
          </span>
        </div>
      )}
      
      <div className="text-center mb-6 pt-2">
        <h3 className="text-2xl font-bold text-white mb-2">{pkg.name}</h3>
        <div className="flex items-baseline justify-center">
          <span className="text-4xl font-bold text-blue-400">${pkg.price}</span>
          <span className="text-gray-400 ml-2">+USPTO fees</span>
        </div>
      </div>
      
      <ul className="space-y-0 mb-6 flex-grow divide-y divide-slate-700/50 max-h-[400px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-slate-800">
        {pkg.features.map((feature, index) => (
          <li key={index} className="flex items-start py-3">
            {feature.included ? (
              <Check className="w-5 h-5 text-blue-400 mr-2 flex-shrink-0 mt-0.5" />
            ) : (
              <X className="w-5 h-5 text-slate-600 mr-2 flex-shrink-0 mt-0.5" />
            )}
            <span className={`text-sm ${
              feature.included ? 'text-gray-200' : 'text-gray-500'
            }`}>
              {feature.name}
            </span>
          </li>
        ))}
      </ul>
      
      <div className="mt-auto">
        <Button
          onClick={() => onGetStarted(pkg)}
          className={`w-full ${
            pkg.popular
              ? 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-amber-500 hover:to-amber-600'
              : 'bg-slate-800 hover:bg-blue-700'
          } text-white font-semibold py-3 transition-all duration-300`}
        >
          Get Started
        </Button>
        
        <p className="text-xs text-gray-500 text-center mt-4">
          *(Govt. filing fee not included)
        </p>
      </div>
    </div>
  );
};

export default PricingCard;
